import Rollbar from 'rollbar'
import { environment } from '../environments/environment'

// ! Ensure accessToken is accurate

const rollbarConfig: Rollbar.Configuration = {
  // enabled: environment.env !== 'dev', // Don't emit when developing on local
  accessToken: '192c8358406c4f168f78cfc072d28c5f',
  captureUncaught: true,
  captureUnhandledRejections: true,
  recorder: {
    enabled: true,
    maskInputOptions: {
      password: true,
      email: true,
    },
  },
  payload: {
    environment: environment.env,
    server: {
      root: 'webpack:///./',
    },
    client: {
      javascript: {
        source_map_enabled: true, // true by default

        // The deploy's version step (replace.build.js) stamps this with the commit SHA the source maps
        // are uploaded under; Rollbar only un-minifies frames when the two match exactly.
        code_version: '5dfafd15cb4fc8c39594cb2bc3feec52f92b8eaf',

        // Optionally have Rollbar guess which frames the error was
        // thrown from when the browser does not provide line
        // and column numbers.
        guess_uncaught_frames: true,
      },
    },
  },
}

export function rollbarFactory() {
  return new Rollbar(rollbarConfig)
}
